const SubMenu = {

    // FIELDS
    "name": "الاسم",
    "description": "الوصف",
    "sub_menu_icon": "الرمز",
    "main_menu": "القائمة الرئيسية",
    "priority": "الأولوية",
    "search": "البحث",

    // PAGE HEADER
    "sub_menu": "القائمة الفرعية",

    // ERROR
    "error_name": "الرجاء إدخال الاسم",
    "error_desc": "الرجاء إدخال الوصف",
    "error_priority_positive": "يجب أن تكون الأولوية إيجابية",
    "error_priority_required": "الرجاء إدخال الأولوية",
    "error_priority_type_error": "الرجاء إدخال أرقام فقط",
    "error_main_menu": "الرجاء تحديد القائمة الرئيسية",
    "error_icon": "أدخل اسم الرمز",

    // TABLE HEADER
    "table_name": "الاسم",
    "table_main_menu": "القائمة الرئيسية",
    "table_description": "الوصف",
    "table_priority": "الأولوية",

}

export default SubMenu